<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN ParaOverride-1" id="_idParaDest-2"> </p>
<p class="Title1">LAST CHANCE TEXACO</p>
<p class="TitleSub">Chronicles of an American Troubadour</p>
<p class="TitleAuthor">RICKIE</p>
<p class="TitleAuthor2">LEE</p>
<p class="TitleAuthor2">JONES</p>
<p class="BT ParaOverride-2"><span class="CharOverride-1"><img alt="" class="_idGenObjectAttribute-1" src="image/V-1.jpg"/></span></p>
<p class="BT-1st-para ParaOverride-3"><span class="CharOverride-2">Grove Press</span></p>
<p class="BT-1st-para ParaOverride-3"><span class="CharOverride-2">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802188809-1.vue?1fcb9f5c